import { render, staticRenderFns } from "./public-view.vue?vue&type=template&id=4bce92d2&scoped=true&"
import script from "./public-view.vue?vue&type=script&lang=js&"
export * from "./public-view.vue?vue&type=script&lang=js&"
import style0 from "./public-view.vue?vue&type=style&index=0&id=4bce92d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce92d2",
  null
  
)

export default component.exports